export default __webpack_public_path__ + "static/media/rudolstadt.d5575fba.webp";